// core
import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'open-raptor-sidebar',
  templateUrl: './raptor-sidebar.component.html',
  styleUrls: ['./raptor-sidebar.component.scss']
})
export class RaptorSidebarComponent implements OnInit, OnDestroy {
  @Input() sidebar: any;
  @Input() form: any;
  cssCalcSizeSupport: boolean = CSS.supports("height: calc-size(auto, size)");
  mobileResize!: any;
  @ViewChild('container') container!: ElementRef<HTMLInputElement>;

  collapsed: boolean = true;

  ngOnInit() {
    if (!this.cssCalcSizeSupport) {
      this.mobileResize = window.addEventListener('resize', this.setElementHeights);
      this.setElementHeights();
    }
  }

  ngOnDestroy(): void {
    if (this.mobileResize) {
      window.removeEventListener('resize', this.mobileResize);
    }
  }

  setElementHeights = () => {
    requestAnimationFrame(() => {
      if (this.container) {
        const selectorsToQuery = [
          '.raptor-total-price-banner',
          '.total-price-arrangement',
          '.raptor-sidebar-section-group-container:not(.mobile-default)'
        ];
        selectorsToQuery.forEach((selector: string) => {
          const elementQuery = this.container.nativeElement.querySelectorAll(selector);
          elementQuery.forEach((element: any) => {
            element.style.setProperty("height", "auto");
            const elementHeight = element.offsetHeight;
            element.style.removeProperty("height");
            element.style.setProperty("--animate-height", `${elementHeight}px`);
          });
        });
      }
    });
  } 


  public toggleView(event: MouseEvent) {
    const { target } = event;
    const isTabletDown = window.matchMedia("(width <= 1023px)");
    
    // Allows any click while collapsed to toggle the sidebar
    // Allows clicks on the 'close' icon or the overlay when expanded to toggle the sidebar
    if (
      target instanceof HTMLElement &&
      isTabletDown.matches &&
      (
        this.collapsed ||
        target.closest(".raptor-sidebar-mobile-details-link") ||
        target.closest(".raptor-sidebar-mobile-overlay")        
      )
    ) {
      this.collapsed = !this.collapsed;
      document.body.classList.toggle("body-no-scroll-tablet-down");
    }
  }


}
